import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import LangControls from "@/mixins/LangControls.mixin";
import FooterLinks from "@/mixins/FooterLinks.mixin";
import {
  Button,
  ButtonThemeEnum,
} from "@/components/shared/Button.component";

// Organization/workspace creation is temporarily halted. This page is kept so
// existing links/redirects to /workspace-setup still resolve, but it only shows
// a notice and a way to log out instead of the (removed) creation form.
@Component({})
export default class WorkspaceSetupName extends mixins(
  LangControls,
  FooterLinks,
) {
  private onLogoutClick() {
    this.$authManager.logout();
  }

  render() {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          padding: "2rem",
          gap: "1rem",
        }}
      >
        <h1>Workspace setup temporarily halted</h1>
        <p>Creating a new organization is currently unavailable.</p>
        <Button onClick={this.onLogoutClick} theme={ButtonThemeEnum.primary}>
          Log out
        </Button>
      </div>
    );
  }
}
